<template>
  <component :is="tag" class="sub-section-title soft small uppercase">
    <slot />
  </component>
</template>

<script>
export default {
  name: 'SubSectionTitle',

  props: {
    size: {
      type: Number,
      default: 1
    }
  },

  computed: {
    tag () {
      return `h${this.size}`
    }
  }
}
</script>

<style lang="sass" scoped>
@import '@/styles/variables.sass'

.sub-section-title
  margin-top: $margin
  border-bottom: solid 2px rgba($font-color, 0.2)
  padding-bottom: $margin * 0.5
</style>
